import type { CloudAllData, Hero } from "@/types/cloud-data";

export function initials(name: string | null | undefined) {
  const words = (name?.trim() || "Player").split(/\s+/);
  return (words.length > 1 ? words[0][0] + words[words.length - 1][0] : words[0].slice(0, 2)).toUpperCase();
}

export function relativeTime(value: string | number | null | undefined) {
  if (value == null || value === "") return "Not recorded";
  const time = new Date(value).getTime();
  if (!Number.isFinite(time)) return "Not recorded";
  const minutes = Math.max(0, Math.floor((Date.now() - time) / 60_000));
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes}m ago`;
  if (minutes < 1440) return `${Math.floor(minutes / 60)}h ago`;
  return `${Math.floor(minutes / 1440)}d ago`;
}

export function numberLabel(value: unknown) {
  return typeof value === "number" && Number.isFinite(value) ? value.toLocaleString() : "—";
}

export function playtimeLabel(value: unknown) {
  return typeof value === "number" && Number.isFinite(value)
    ? `${Math.floor(value / 3600).toLocaleString()}h ${Math.floor((value % 3600) / 60)}m` : "—";
}

export function providerLabel(provider: string) {
  return ({ password: "Email / password", email: "Email", google: "Google", discord: "Discord", apple: "Apple", playfab: "PlayFab", device: "Device" } as Record<string, string>)[provider] ?? provider;
}

// A missing or malformed save stays unavailable. Do not invent default player data.
export function parseCloudSave(raw: string | undefined): CloudAllData | null {
  if (!raw) return null;
  try {
    const value = JSON.parse(raw);
    if (!value || typeof value !== "object" || !value.userData || typeof value.userData !== "object" || Array.isArray(value.userData)) return null;
    return value as CloudAllData;
  } catch { return null; }
}

export function savedHeroes(cloud: CloudAllData | null): Hero[] {
  const heroes = cloud?.heroesData?.heroes;
  return Array.isArray(heroes) ? heroes.filter(hero => hero && typeof hero === "object") : [];
}

export function prettyValue(value: string) {
  try { return JSON.stringify(JSON.parse(value), null, 2); } catch { return value; }
}
